var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "390.5 320 578.5 849"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000,1484.000000) scale(0.100000,-0.100000)",
  fill: "#c18c5e",
  stroke: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7810 11144 l-495 -495 282 -277 282 -277 5 -1683 c2 -926 1 -1682 -4 -1680 -4 2 -388 377 -853 833 l-845 830 -1 1598 c-1 878 -4 1597 -9 1597 -4 0 -516 -508 -1137 -1130 l-1130 -1130 228 -228 227 -227 0 -617 0 -617 898 -901 897 -901 425 1 425 0 1343 1343 1342 1342 0 1558 0 1557 -693 0 -692 0 -495 -496z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4360 3735 l0 -585 2665 0 2665 0 0 585 0 585 -2665 0 -2665 0 0 -585z"
}))));
export { SvgLogo as ReactComponent };